import React from "react";

const Footer = () => {
  return (
    <footer style={{
      background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
      backdropFilter: 'blur(15px)',
      borderTop: '1px solid rgba(255, 215, 0, 0.3)',
      padding: '2rem',
      textAlign: 'center',
      color: 'rgba(255, 255, 255, 0.8)',
      fontFamily: 'Inter, sans-serif',
      boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.3)',
      position: 'relative'
    }}>
      <div style={{
        background: 'linear-gradient(45deg, #FFD700, #FF69B4, #98FB98)',
        backgroundSize: '300% 300%',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        animation: 'gradientShift 4s ease-in-out infinite',
        fontSize: '1.1rem',
        fontWeight: '600',
        marginBottom: '0.5rem'
      }}>
        🌺 xxxmemo.com - 探索東南亞夜晚的魅力
      </div>
      <p style={{ margin: 0, fontSize: '0.9rem', fontWeight: '300' }}>
        &copy; 2025 xxxmemo.com. 保留所有權利 | 讓每個夜晚都成為難忘的回憶 ✨
      </p>
      <style jsx>{`
        @keyframes gradientShift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;